import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import {
  SearchCustomersDocument,
  SearchCustomersQuery,
  SearchCustomersQueryVariables,
} from "@hydrologiq/gql-experience/graphql"

/**
 * Hook for fetching customers formatted for use in a select dropdown.
 * Uses the SearchCustomers query with an empty search term to load all customers.
 *
 * @returns A flat list of customers with id and name, plus loading state
 */
export function useCustomersForSelect() {
  const { data, loading } = useQueryWithEndpoint<
    SearchCustomersQuery,
    SearchCustomersQueryVariables
  >(
    SearchCustomersDocument,
    {
      variables: { query: "", page: 1, per_page: 100 },
      fetchPolicy: "cache-first",
    },
    "primary",
  )

  const customers: Array<{ id: string; name: string }> =
    data?.customers?.data?.map((customer) => ({
      id: customer.id,
      name: customer.name,
    })) ?? []

  return { customers, loading }
}
